__webpack_require__.p = "/dev/refactor-lyrics-view-as-position-constructor/";